/**
 * 文件尺寸转换
 * @param fileSize
 */
export function getFileSize(fileSize: number): string {
    const size = Number(fileSize) || 0;
    let sizeString = fileSize + '';
    if (size < 1024) {
        sizeString = size + 'B';
    } else if (size < 1048576) {
        sizeString = parseFloat((size / 1024).toFixed(1)) + 'KB';
    } else if (fileSize < 1073741824) {
        sizeString = parseFloat((size / 1048576).toFixed(1)) + 'MB';
    } else {
        sizeString = parseFloat((size / 1073741824).toFixed(1)) + 'GB';
    }
    return sizeString;
}
